// src/utils/curriculum.ts
// Yahan pe hum saare subjects, credits, marking scheme define karenge for all years/semesters/Branchs

export type Subject = {
  code: string;
  name: string;
  credits: number;
  marking: {
    CA?: number;    // Internal/CA
    InSem?: number; // In-Sem
    EndSem?: number;// End-Sem
    LabCA?: number; // Lab CA
    total: number;
  };
  type: "Theory" | "Lab" | "Project" | "Exposure";
};

export type Curriculum = {
  [year: string]: {
    [semester: string]: {
      [Branch: string]: Subject[];
    }
  }
};

export const curriculum: Curriculum = {
  "First Year": {
    "Semester 1": {
      "P": [
        { code: "316U06C101", name: "Applied Mathematics – I", credits: 4, marking: { CA: 20, InSem: 30, EndSem: 50, total: 125 }, type: "Theory" },
        { code: "316U06C101", name: "Applied Mathematics TUT", credits: 1, marking: { LabCA: 25, total: 25 }, type: "Lab" },
        { code: "316U06C102", name: "Engineering Physics", credits: 2, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C103", name: "Engineering Chemistry", credits: 2, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C104", name: "Basic Electrical Engineering", credits: 2, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C105", name: "Engineering Drawing", credits: 3, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C106", name: "Biology for Engineers", credits: 2, marking: { CA: 50, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C107", name: "Structured Programming Methodology", credits: 3, marking: { LabCA: 50, CA: 20, InSem: 30, EndSem: 50, total: 150 }, type: "Theory" },

        { code: "316U06L101", name: "Applied Science Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L102", name: "Basic Electrical Engineering Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L103", name: "Engineering Drawing Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L104", name: "Maker Space Laboratory – I", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" }
      ],
      "C": [
        { code: "316U06C101", name: "Applied Mathematics – I", credits: 4, marking: { LabCA: 25, CA: 20, InSem: 30, EndSem: 50, total: 125 }, type: "Theory" },
        { code: "316U06C102", name: "Engineering Physics", credits: 2, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C103", name: "Engineering Chemistry", credits: 2, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C104", name: "Basic Electrical Engineering", credits: 2, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C105", name: "Engineering Drawing", credits: 3, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C106", name: "Biology for Engineers", credits: 2, marking: { CA: 50, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C107", name: "Structured Programming Methodology", credits: 3, marking: { LabCA: 50, CA: 20, InSem: 30, EndSem: 50, total: 150 }, type: "Theory" },

        { code: "316U06L101", name: "Applied Science Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L102", name: "Basic Electrical Engineering Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L103", name: "Engineering Drawing Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L104", name: "Maker Space Laboratory – I", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
      ]
    },
    "Semester 2": {
      "P": [
        { code: "316U06C201", name: "Applied Mathematics – II", credits: 4, marking: {  CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C201", name: "Applied Mathematics TUT", credits: 1, marking: { LabCA: 25, total: 25 }, type: "Lab" },
        { code: "316U06C202", name: "Program-Specific Science Course", credits: 3, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C203", name: "Program-Specific Core Course", credits: 3, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C204", name: "Environmental Science", credits: 2, marking: { LabCA: 50, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C205", name: "Object-Oriented Programming Methodology", credits: 3, marking: { LabCA: 50, EndSem: 50, total: 100 }, type: "Lab" },
        { code: "316U06T201", name: "Presentation and Communication Skills", credits: 2, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L201", name: "Program-Specific Science Course Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L202", name: "Program-Specific Core Course Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L203", name: "Maker Space Laboratory – II", credits: 1, marking: { LabCA: 50, EndSem: 50, total: 100 }, type: "Lab" },
        { code: "316U06X101", name: "Sports", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
      ],
      "C": [
        { code: "316U06C201", name: "Applied Mathematics – II", credits: 4, marking: { LabCA: 25, CA: 20, InSem: 30, EndSem: 50, total: 125 }, type: "Theory" },
        { code: "316U06C202", name: "Program-Specific Science Course", credits: 3, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C203", name: "Program-Specific Core Course", credits: 3, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C204", name: "Environmental Science", credits: 2, marking: { LabCA: 50, EndSem: 50, total: 100 }, type: "Theory" },
        { code: "316U06C205", name: "Object-Oriented Programming Methodology", credits: 3, marking: { LabCA: 50, EndSem: 50, total: 100 }, type: "Lab" },
        { code: "316U06T201", name: "Presentation and Communication Skills", credits: 2, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L201", name: "Program-Specific Science Course Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L202", name: "Program-Specific Core Course Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
        { code: "316U06L203", name: "Maker Space Laboratory – II", credits: 1, marking: { LabCA: 50, EndSem: 50, total: 100 }, type: "Lab" },
        { code: "316U06X101", name: "Sports", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab" },
      ]
      
    }
  },
  "Second Year": {
    "Semester 3": { 
      "CSBS": [
        { code: "216U50C301", name: "Computational Statistics, Probability, and Calculus", credits: 4, marking: { LabCA: 25, CA: 20, InSem: 30, EndSem: 50, total: 125 },type: "Theory"},
        { code: "216U50C302", name: "Data Structures",credits: 3, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory"},
        { code: "216U50C303", name: "Computer Organization and Architecture",credits: 3,marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 },type: "Theory"},
        { code: "216U50C304", name: "Discrete Mathematics", credits: 4,marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 },type: "Theory"},
        { code: "216U50C305", name: "Fundamentals of Economics", credits: 3, marking: { CA: 20, InSem: 30, EndSem: 50, total: 100 }, type: "Theory"},
        { code: "216U061306", name: "Indian Knowledge System", credits: 2, marking: { CA: 50, total: 50 }, type: "Theory" },
        { code: "216U50L301", name: "Object Oriented Programming Laboratory", credits: 2, marking: { LabCA: 100, total: 100 }, type: "Lab"},
        { code: "216U50L302", name: "Data Structures Laboratory", credits: 1, marking: { LabCA: 50, total: 50 }, type: "Lab"},
        { code: "216U50L303", name: "Digital Design Laboratory", credits: 2, marking: { LabCA: 100, total: 100 }, type: "Lab"},
      ]
      
    }
},
}
